import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/bridges.json";
import fr from "@/locales/fr/puzzle-types/bridges.json";

export const BRIDGES_NS = "puzzle-types/bridges";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerBridgesTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", BRIDGES_NS))
    i18n.addResourceBundle("en", BRIDGES_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", BRIDGES_NS))
    i18n.addResourceBundle("fr", BRIDGES_NS, fr, true, true);
}
